import { render, staticRenderFns } from "./RequestItem.vue?vue&type=template&id=7822eb8f&"
import script from "./RequestItem.vue?vue&type=script&lang=ts&"
export * from "./RequestItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports